import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "updatedTime",
})
export class UpdatedTimePipe implements PipeTransform {
  transform(value: Date, ...args: any[]): any {
    var date = new Date(value);
    var now_utc = Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    );
    var updatedTime = new Date(now_utc).getTime();
    var today = new Date();
    var currentTime = today.getTime();

    var yearMs = 365 * 24 * 60 * 60 * 1000;
    var monthMs = 30 * 24 * 60 * 60 * 1000;
    var weekMs = 7 * 24 * 60 * 60 * 1000;
    var dayMs = 24 * 60 * 60 * 1000;
    var hourMS = 60 * 60 * 1000;
    var minMs = 60 * 1000;
    var diffMs = currentTime - updatedTime;

    if (diffMs > yearMs) {
      return "Updated year ago";
    } else if (diffMs > monthMs) {
      return "Updated months ago";
    } else if (diffMs > weekMs) {
      return "Updated weeks ago";
    } else if (diffMs > dayMs) {
      return "Updated days ago";
    } else if (diffMs > hourMS) {
      return "Updated hours ago";
    } else if (diffMs > minMs) {
      return "Updated mins ago";
    } else return "Updated just now";
  }
}
